module.exports = __webpack_public_path__ + "img/PL08340.86e416e2.png";